import { Button } from './button.js';
import { Text } from './text.js';

const Toast = {
  baseStyle: {
    container: {
      ".chakra-toast &": {
        borderColor: "black"
      },
      display: "flex",
      paddingRight: "20px",
      borderRadius: "0.1875rem",
      bgColor: "black",
      color: "white",
      position: "relative",
      marginBottom: "1rem",
      border: "1px solid",
      paddingY: "0.75rem",
      paddingX: "1rem",
      gap: "0.65rem",
      alignItems: "center"
    },
    icon: {
      top: "12px",
      color: "white",
      _dark: {
        color: "white"
      }
    },
    title: {
      ...Text.variants["paragraph-2"]
    },
    closeButton: {
      ...Button.baseStyle,
      ...Button.sizes?.xs,
      ...Button.variants?.tertiary,
      width: "xs",
      color: "grayscale.0",
      _hover: {
        color: "slate.900",
        bgColor: "lightBlueAlpha.300"
      }
    },
    button: {
      ...Button.baseStyle,
      ...Button.sizes?.sm,
      // iris button outline variant, dark mode only
      border: "1px solid",
      color: "white",
      borderColor: "white",
      backgroundColor: "transparent",
      _active: {
        backgroundColor: "transparent"
      },
      _hover: {
        backgroundColor: "rgba(74, 108, 125, 0.2)"
      }
    }
  },
  defaultProps: {
    status: "info"
  }
};

export { Toast };
